// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.log-tooltip {\r\n  max-width: 800px;\r\n  word-break: normal;\r\n  white-space: pre;\r\n  font-family: monospace;\r\n  padding: 15px;\r\n  cursor: text;\r\n  background-color: #f8f8f8;\r\n  border: 1px solid #eaeaea;\r\n  border-radius: 5px;\r\n  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\r\n          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\r\n  line-height: 1.5;\r\n  font-size: 14px;\r\n  color: #333;\n}\r\n", ""]);
// Exports
module.exports = exports;
